<template>
  <pt-detection-corpus-list class="pt-detection-corpus-list__page"></pt-detection-corpus-list>
</template>

<script>
import PtDetectionCorpusList from 'cps/gene-product/pt-detection-corpus-list/withData'
export default {
  name: 'pt-detection-corpus-list__view',
  components: {
    'pt-detection-corpus-list': PtDetectionCorpusList
  }
}
</script>
